import { render, staticRenderFns } from "./DraggableGrade.vue?vue&type=template&id=ae8174b2&"
import script from "./DraggableGrade.vue?vue&type=script&lang=js&"
export * from "./DraggableGrade.vue?vue&type=script&lang=js&"
import style0 from "./DraggableGrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports